import React from "react";


import img1 from "../../media/images/delhi.png"
import img2 from "../../media/images/noida.png"
import img3 from "../../media/images/greater-noida.png"
import img4 from "../../media/images/gurgaon.png"
import img5 from "../../media/images/ghaziabad.png"
import img6 from "../../media/images/faridabad.png"


import { useSelector, useDispatch } from "react-redux";
import { setCityName } from "../../store/citySlice";

function ChooseLocationFemale({ setShowFmchooseLocation, setCartList  }) {

  // const cityName = useSelector((state) => state.city.cityName);



  const cityName  = useSelector((state)=>state.city.cityName);
  const dispatch = useDispatch();



  // console.log("cyrrent-cityName", cityName);

  const handleSetCityToNoida = () => {
    dispatch(setCityName("Noida"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };


    const handleSetCityToDelhi = () => {
    dispatch(setCityName("Delhi"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };


    const handleSetCityToGNoida = () => {
    dispatch(setCityName("Greater Noida"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };

    const handleSetCityToGurgaon = () => {
    dispatch(setCityName("Gurgaon"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };
  

 const handleSetCityToGhaziabad= () => {
    dispatch(setCityName("Ghaziabad"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };


 const handleSetCityToFaridabad= () => {
    dispatch(setCityName("Faridabad"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };


  const handleSetCityToOthers= () => {
    dispatch(setCityName("Others"));
    setShowFmchooseLocation(false);
    setCartList(true);
  };

  
  

  return (
    
    <div className="choose-main-location-sectionCard">

    <div className="choose-location-sectionCard">
      

      <div className="choose-location-sectionCard-content"> 
      <div className="choose-location-sectionCard-heading">
        Select Your Location   <i class="fa-solid fa-location-dot"></i>
      </div>


<div className="choose-location-sectionCard-heading-row">

  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToDelhi}>
    <div className="choose-location-sec-card-img"> <img src={img1}></img></div>
    Delhi</div>
   <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToNoida}>
        <div className="choose-location-sec-card-img"> <img src={img2}></img></div>

    Noida
    </div>
  <div className="choose-location-sectionCard-heading-cols"  onClick={handleSetCityToGNoida}>
        <div className="choose-location-sec-card-img"> <img src={img3}></img></div>
  Greater Noida
    </div>
  <div className="choose-location-sectionCard-heading-cols"  onClick={handleSetCityToGurgaon} >
        <div className="choose-location-sec-card-img"> <img src={img4}></img></div>

    Gurgaon</div>
  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToGhaziabad} >
        <div className="choose-location-sec-card-img"> <img src={img5}></img></div>

 Ghaziabad
    </div>
  <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToFaridabad} >
        <div className="choose-location-sec-card-img"> <img src={img6}></img></div>

  Faridabad
    </div>
  {/* <div className="choose-location-sectionCard-heading-cols" onClick={handleSetCityToOthers} >
        <div className="choose-location-sec-card-img"> <img src={img1}></img></div>

    Others
    </div> */}


</div>



      </div>
    </div>
    </div>
  );
}

export default ChooseLocationFemale;


// export default ChooseLocationFemale